import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Benefits = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Benefits & Compensation</h1>
          <p className="text-gray-500 text-sm">Manage employee packages, health insurance, and allowances.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-6 border border-gray-100 shadow-sm flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-4">
            <SafeIcon name="Heart" size={32} />
          </div>
          <h3 className="text-lg font-bold text-gray-800 mb-2">Health Insurance Plans</h3>
          <p className="text-sm text-gray-500 mb-6 leading-relaxed">
            Comprehensive medical coverage including dental and vision. Manage provider networks and employee enrollments.
          </p>
          <button className="px-6 py-2 bg-red-500 text-white font-bold rounded-lg hover:bg-red-600 transition-colors">
            Manage Enrollments
          </button>
        </div>

        <div className="card p-6 border border-gray-100 shadow-sm flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-blue-50 text-[#11469A] rounded-full flex items-center justify-center mb-4">
            <SafeIcon name="DollarSign" size={32} />
          </div>
          <h3 className="text-lg font-bold text-gray-800 mb-2">Allowances & Bonuses</h3>
          <p className="text-sm text-gray-500 mb-6 leading-relaxed">
            Track transport, housing allowances, and performance-based bonus structures across different departments.
          </p>
          <button className="px-6 py-2 bg-[#11469A] text-white font-bold rounded-lg hover:bg-[#0d3678] transition-colors">
            View Structures
          </button>
        </div>
      </div>

      <div className="card p-6 mt-6">
        <h3 className="font-bold text-gray-800 mb-4">Pension & Retirement (SSNIT)</h3>
        <div className="bg-gray-50 p-4 rounded-lg flex justify-between items-center border border-gray-100">
          <div>
            <p className="font-bold text-gray-700">Tier 1 & Tier 2 Tracking</p>
            <p className="text-xs text-gray-500 mt-1">Export monthly contribution sheets for compliance.</p>
          </div>
          <button className="flex items-center gap-2 text-sm font-bold text-gray-600 bg-white border border-gray-200 px-4 py-2 rounded hover:bg-gray-100">
            <SafeIcon name="Download" size={16} /> Generate Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default Benefits;